import React, { useState, useEffect } from "react";
import { CModal, CModalBody } from "@coreui/react";
import crossButton from "../../../components/assets/image/crossButton.svg";

const AddStatusPopupForDataRequest = ({ userData = {}, buttonLabel = "Select Status", onSubmit }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState("");

    const statusOptions = [
        { value: 0, label: "Pending" },
        { value: 1, label: "In Progress" },
        { value: 2, label: "Completed" },
    ];

    useEffect(() => {
        if (userData.status) {
            setSelectedStatus(userData.status);
        }
    }, [userData]);

    const handleSubmit = () => {
        if (selectedStatus === "") {
            alert("Please select a status");
            return;
        }

        console.log("DATATTATA::::", selectedStatus);
        onSubmit(selectedStatus);
        setIsModalVisible(false);
    };

    return (
        <div>
            <button
                onClick={() => setIsModalVisible(true)}
                style={{
                    backgroundColor: "black",
                    color: "white",
                    border: "none",
                    cursor: "pointer",
                    borderRadius: "4px",
                    fontSize: "10px",
                    minWidth: "60px",
                    height: "24px",
                    padding: "2px 5px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {userData.status ? "Update Status" : buttonLabel}
            </button>

            <CModal alignment="center" visible={isModalVisible} onClose={() => setIsModalVisible(false)}>
                <CModalBody style={{ padding: "20px", position: "relative" }}>
                    <img
                        onClick={() => setIsModalVisible(false)}
                        src={crossButton}
                        alt="close"
                        style={{ position: "absolute", top: 10, right: 10, cursor: "pointer", width: "20px", height: "20px" }}
                    />

                    <h4 style={{ textAlign: "center", marginBottom: "20px" }}>{userData.status ? "Update Status" : buttonLabel}</h4>

                    <label className="form-label fw-bold">Status</label>
                    <select
                        value={selectedStatus}
                        onChange={(e) => setSelectedStatus(Number(e.target.value))}
                        className="form-control mb-3"
                    >
                        <option value="">-- Select Status --</option>
                        {statusOptions.map((status) => (
                            <option key={status.value} value={status.value}>
                                {status.label}
                            </option>
                        ))}
                    </select>

                    <button onClick={handleSubmit} className="w-100 btn btn-md btn-warning fw-bold text-light button-color"
                        type="button"
                    >
                        Submit
                    </button>
                </CModalBody>
            </CModal>
        </div>
    );
};

export default AddStatusPopupForDataRequest;
